<template>
	<div @click="handleFileClick"  class="rp-messenger-attachment-wrapper">
		<div class="attachment-name">
			<p :title="fileName" class="attachment-file-name-body">
                <span class="attachment-file-name">
                    <i v-if="isLoading"/>
                    <AttachmentIcon v-else />
                    {{ fileName }}
                </span>
			</p>
		</div>
	</div>
</template>

<script>
import Message from '../../models/Message'
import AttachmentIcon from './AttachmentIcon'
export default {
    name: 'AttachmentItem',
    components: {
        AttachmentIcon
    },
	props: {
		attachment: {
			type: String,
			required: true
        },
        percentage: {
            type: Number,
            required: true
        },
        uploadStatus: {
            type: String,
            required: true
        }
	},

    data() {
        return {
            isLoading: false
        }
    },

    computed: {

        fileName() {
            const [ParentBucket, Bucket, Name] = this.attachment.split('/');
            return Name;
		},
        showPercentage() {
            const { status } = this;

            if(status && status === "uploading") {
                return true;
            }

            return false;
        }

    },

    methods: {

        async handleFileClick() {
            if (this.isLoading) return

            this.isLoading = true;
            
            const response = await Message.fileDownload(this.attachment);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.fileName);
            document.body.appendChild(link);
            link.click();

            this.isLoading = false;
        }

    }
}
</script>

<style lang="scss">
.rp-messenger-attachment-wrapper {
    .attachment-name {
            display: flex;

        p {
            margin: 0;
        }

        p.attachment-file-name-body {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .attachment-file-name {
                svg {
                    vertical-align: middle;
                }
            }
        }
    }
}
</style>
